<template>
  <el-form :model="form" size="mini" :rules="rules" ref="form" class="form-horizontal flex-column prepend-equal">
    <div class="flex-row flex-wrap justify-content-between">
      <el-form-item prop="deptName">
        <el-input placeholder="" v-model="form.deptName" class="required" :disabled="isShow">
          <template slot="prepend">部门名称</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="pId">
        <div class="flex-row" v-if="form.pId !== 0" :class="{ required: getIsFill }">
          <span class="el-input-group__prepend select-prepend">上级部门</span>
          <el-select v-model="form.pId" :disabled="this.formType !== '新增'" filterable clearable placeholder="请选择" class="flex-1">
            <el-option v-for="item in deptList" :key="item.id" :label="item.deptName" :value="item.id"> </el-option>
          </el-select>
        </div>
      </el-form-item>
    </div>
    <div class="flex-row flex-wrap justify-content-between">
      <el-form-item prop="remark" class="flex-1">
        <div style="display: flex">
          <span class="el-input-group__prepend select-prepend" style="width: 103px !important">说明</span>
          <el-input v-model="form.remark" type="textarea" maxlength="200" show-word-limit :disabled="isShow"></el-input>
        </div>
      </el-form-item>
    </div>

    <div class="text-center p-t-sm" v-if="!isShow">
      <button class="btn btn-sm btn-primary btn-save" type="button" @click="submitForm" v-loading="submitLoading">
        确定
      </button>
      <button class="btn btn-sm btn-white btn-cancle" data-dismiss="modal">取消</button>
    </div>
  </el-form>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'deptForm',
  props: {
    formType: {
      type: String,
      default: '',
    },
    deptList: {
      type: Array,
      default: [],
    },
    dept: {
      type: Object,
      default: null,
    },
    modalShow: {
      type: Boolean,
      default: false,
    },
    isFill: {
      type: Boolean,
      default: false,
    },
    operType: {
      type: String,
    },
  },
  data() {
    return {
      submitLoading: false,
      form: {
        deptName: '',
        remark: '',
        pId: '',
      },
      rules: {
        deptName: [
          {
            required: true,
            message: '请输入类型名称',
            trigger: 'blur',
          },
        ],
        // pId: [{
        //   validator: (rule, value, callback) => {
        //     if (!this.isFill || (this.isFill && value)) {
        //       callback()
        //     }else {
        //       callback(new Error('请选择上级部门!'))
        //     }
        //   },
        //   trigger: 'change'
        // }]
      },
    }
  },
  computed: {
    isShow() {
      return this.operType === 'show'
    },
    getIsFill() {
      if (this.formType === '新增') {
        return false
      }
      return this.isFill
    }
  },
  watch: {
    modalShow(to) {
      this.$refs.form.resetFields()
      if (this.dept !== null) {
        this.form = {
          ...this.dept,
        }
      }

      if (to && this.formType === '新增') {
        for (let i in this.form) {
          this.form[i] = ''
        }
      }
    },
  },
  mounted() {
    if (this.dept !== null) {
      this.form = {
        ...this.dept,
      }
    }
  },
  methods: {
    ...mapActions(['alertToggle', 'fetchData']),

    submitForm() {
      const _this = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url = this.formType === '新增' ? 'DEPT_MNG.ADD' : 'DEPT_MNG.UPDATE'
          let deptInfo = {
            id: this.form.id,
            deptName: this.form.deptName,
            remark: this.form.remark,
            pId: this.form.pId,
          }
          let params = {
            deptInfo: JSON.stringify(deptInfo),
          }
          this.submitLoading = true
          this.fetchData({
            url,
            method: 'post',
            params,
            isLoading: true,
          })
            .then((res) => {
              _this.alertToggle({
                alertType: 'success',
                alertContent: '操作成功',
              })
              _this._finishOperate()
            })
            .catch((err) => {
              _this.submitLoading = false
              let field = _this.$refs.form.fields.filter((field) => field.prop === 'deptName')[0]
              field.validateMessage = err
              field.validateState = 'error'
              return false
            })
        } else {
          return false
        }
      })
    },
    _finishOperate() {
      this.submitLoading = false
      this.$emit('success')
    },
  },
}
</script>
